





































import { computed, defineComponent, PropType } from "@vue/composition-api";
import { CreatorService } from "@scrile/api-provider/dist/api/CreatorServicesProvider";
import { $t } from "@/lib/i18nHelpers";
import { BaseMenuItem } from "@/types";
import BaseIcon from "@/components/BaseIcon";
import BaseMenu from "@/components/BaseMenu";
import BaseSpinner from "@/components/BaseSpinner";
import InfiniteScroll from "@/components/InfiniteScroll";
import ModalView from "@/components/ModalView";
import CreatorServiceItem from "./CreatorServiceItem.vue";
import { CATEGORIES_OPTIONS } from "../const";

export default defineComponent({
  name: "CreatorServiceListModal",
  components: {
    BaseIcon,
    BaseMenu,
    BaseSpinner,
    CreatorServiceItem,
    InfiniteScroll,
    ModalView,
  },
  props: {
    title: { type: String, required: true },
    items: { type: Array as PropType<CreatorService[]>, required: true },
    loading: { type: Boolean, default: false },
    enableScroll: { type: Boolean, default: false },
    selectedFilter: { type: String, default: "" },
  },
  setup(props, { emit }) {
    const filters = computed<BaseMenuItem[]>(() => {
      const result = CATEGORIES_OPTIONS.map(i => ({
        text: i.text,
        name: i.value,
        class: i.value === props.selectedFilter ? "fw-600" : "",
      }));

      result.unshift({
        text: $t("All categories"),
        name: "",
        class: !props.selectedFilter ? "fw-600" : "",
      });

      return result;
    });

    const activeFilterName = computed(() => filters.value.find(i => i.name === props.selectedFilter)?.text);

    const onFilterSelect = (v: string) => {
      if (props.selectedFilter === v) return;
      emit("update:filter", v);
    };

    return {
      filters,
      activeFilterName,
      onFilterSelect,
    };
  },
});
